import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LayoutComponent } from "../layout/layout.component";
import { AuthComponent } from "../pages/shared/auth/auth.component";
import { NoAuthGuard } from "../shared/services";

const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      // -------------------------------------------------------------------------------
      // communities
      // -------------------------------------------------------------------------------
      {
        path: "communities",
        loadChildren: () =>
          import(
            "../pages/communities/community-feed/community-feed.module"
          ).then((m) => m.CommunityFeedModule),
      },
      {
        path: "community-editor",
        loadChildren: () =>
          import(
            "../pages/communities/community-editor/community-editor.module"
          ).then((m) => m.CommunityEditorModule),
      },
      {
        path: "community/:communityName",
        loadChildren: () =>
          import(
            "../pages/communities/community-viewer/community-viewer.module"
          ).then((m) => m.CommunityViewerModule),
      },
      // -------------------------------------------------------------------------------
      // discussions
      // -------------------------------------------------------------------------------
      {
        path: "home",
        loadChildren: () =>
          import(
            "../pages/discussions/discussion-feed/discussion-feed.module"
          ).then((m) => m.DiscussionFeedModule),
      },
      {
        path: "discussion-editor",
        loadChildren: () =>
          import(
            "../pages/discussions/discussion-editor/discussion-editor.module"
          ).then((m) => m.DiscussionEditorModule),
      },
      {
        path: "discussion/:discussion",
        loadChildren: () =>
          import(
            "../pages/discussions/discussion-viewer/discussion-viewer.module"
          ).then((m) => m.DiscussionViewerModule),
      },
      // -------------------------------------------------------------------------------
      // shared
      // -------------------------------------------------------------------------------
      {
        path: "",
        loadChildren: () =>
          import("../pages/shared/app-info/app-info.module").then(
            (m) => m.AppInfoModule
          ),
      },
      {
        path: "profile/:username",
        loadChildren: () =>
          import("../pages/shared/profile/profile.module").then(
            (m) => m.ProfileModule
          ),
      },
      {
        path: "invites",
        loadChildren: () =>
          import("../pages/shared/invite-manager/invite-manager.module").then(
            (m) => m.InviteManagerModule
          ),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("../pages/shared/settings/settings.module").then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: "error",
        loadChildren: () =>
          import("../pages/shared/error/error.module").then(
            (m) => m.ErrorModule
          ),
      },
    ],
  },
  // -------------------------------------------------------------------------------
  // auth guard
  // -------------------------------------------------------------------------------
  {
    path: "",
    component: AuthComponent,
    canActivate: [NoAuthGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("../pages/shared/auth/auth.module").then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "error",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
  providers: [NoAuthGuard],
})
export class AppRoutingModule {}
